import React, { useState } from 'react'
import PropTypes from 'prop-types'
import {
    classOptions,
    professionOptions,
    rarityOptions,
    walletHeroesSortOptions
} from '../../constants/menu-options'
import Grid from '@mui/material/Grid'
import SortSelecter from '../SortSelecter'
import SelectWithLabel from '../SelectWithLabel'
import './HeroLookupSortFilter.css'

const HeroLookupSortFilter = ({ onFiltersChange, onSortChange, values, visible }) => {
    const [sort, setSort] = useState('id')

    const handleSortChange = ({ target }) => {
        setSort(target.value)
        onSortChange(target.value)
    }

    if (!visible)
        return null

    return (
        <Grid container className='hero-lookup-sort-filter' justifyContent='center'>
            <Grid item className='section'>
                <SortSelecter name='sort' value={sort} onChange={handleSortChange}>
                    {walletHeroesSortOptions}
                </SortSelecter>
            </Grid>
            <Grid item className='section'>
                <div className='filter-label'>
                    Filters:
                </div>
                    <SelectWithLabel
                        label='Rarity'
                        name='rarity'
                        onChange={onFiltersChange}
                        value={values.rarity}
                    >
                        {rarityOptions(true, null, 'pascal')}
                    </SelectWithLabel>
                    <SelectWithLabel
                        label='Main Class'
                        name='mainClass'
                        onChange={onFiltersChange}
                        value={values.mainClass}
                    >
                        {classOptions(true, null)}
                    </SelectWithLabel>
                    <SelectWithLabel
                        label='Profession'
                        name='profession'
                        onChange={onFiltersChange}
                        value={values.profession}
                    >
                        {professionOptions(true, null, 'pascal')}
                    </SelectWithLabel>
            </Grid>
        </Grid>
    )
}

HeroLookupSortFilter.propTypes = {
    onFiltersChange: PropTypes.func,
    onSortChange: PropTypes.func,
    values: PropTypes.object,
    visible: PropTypes.bool
}

HeroLookupSortFilter.defaultProps = {
    onFiltersChange: () => { },
    onSortChange: () => { },
    visible: true
}

export default HeroLookupSortFilter
